<!-- =========================================================================================
    File Name: NotAuthorized.vue
    Description: Not Authorized Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div class="flex w-full bg-img" :class="{'h-screen': size === 'large'}">
		<div
			class="
				vx-col
				flex
				items-center
				justify-center
				flex-col
				sm:w-1/2
				md:w-3/5
				lg:w-3/4
				xl:w-3/5
				mx-auto
				text-center
			"
		>
			<img
				:class="{'img-size': size === 'large', 'img-small': size === 'small'}"
				src="@/assets/images/pages/not-authorized.png"
				alt="graphic-not-authorized"
				class="mx-auto mb-4"
			/>
			<h1
				class="sm:mx-0 mx-4 sm:mb-2 mb-1 g-subtitle"
				:class="{'text-3xl': size === 'large', 'text-2xl': size === 'small'}"
				v-text="$t('Roles.Permissions.NotPermissions')"
			></h1>
			<p
				v-if="size === 'large'"
				class="vs-table-text sm:mx-0 mx-4 sm:mb-12 mb-6"
				v-text="$t('Roles.Permissions.NotPermissionsText') + ' ' + message"
			></p>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		size: {
			type: String,
			default: "large",
		},
		message: {
			type: String,
			default: "",
		},
	},
};
</script>
<style lang="scss" scoped>
.img-size {
	margin-top: -100px;
}

.img-small {
	width: 150px;
	height: auto;
}
</style>
